// extracted by mini-css-extract-plugin
export default {"tab":"NavTab_tab__iRd1U","active":"NavTab_active__ioAc5","error":"NavTab_error__tY1MX","showError":"NavTab_showError__OwfyP","number":"NavTab_number__XYdL5"};